// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import ContactsIcon from "@material-ui/icons/Contacts";
import AddShoppingCartIcon from "@material-ui/icons/AddShoppingCart";
import AssessmentIcon from "@material-ui/icons/Assessment";
import ArrowRight from "@material-ui/icons/ArrowRight";
// core components/views for Admin layout
import DashboardPage from "views/Dashboard/Dashboard.js";
import Produtos from "views/Produtos/Produtos.js";
import Clientes from "views/Clientes/Clientes.js";
import Pedidos from "views/Pedidos/Pedidos.js";
import Carrinho from "views/Carrinho/Carrinho";
import Relatorios from "views/Relatorios/relatorios.js";
//import Relatorio1 from "views/Relatorios/EGR1000/EGR1000.js";
//import Relatorio2 from "views/Relatorios/EIR6000/EIR6000.js";
//import Relatorio3 from "views/Relatorios/EIR4002/EIR4002.js";
//import Relatorio4 from "views/Relatorios/PRONTAENTREGA/prontaentrega.js";
//import Relatorio5 from "views/Relatorios/PROGRAMACAO/programacao.js";
//import Relatorio6 from "views/Relatorios/VENDAANALITICO/vendaanalitico.js";

const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    key: "0",
    rtlName: "Dashboard",
    icon: Dashboard,
    component: DashboardPage,
    layout: "/admin",
    click: "open",
  },
  {
    path: "/table",
    name: "Clientes",
    key: "1",
    rtlName: "Clientes",
    icon: SupervisorAccountIcon,
    component: Clientes,
    layout: "/admin",
    click: "open",
  },
  {
    path: "/produtos",
    name: "Produtos",
    key: "2",
    rtlName: "Produtos",
    icon: ShoppingBasketIcon,
    component: Produtos,
    layout: "/admin",
    click: "open",
  },
  {
    path: "/carrinho",
    name: "Carrinho",
    key: "3",
    rtlName: "Carrinho",
    icon: AddShoppingCartIcon,
    component: Carrinho,
    layout: "/admin",
    click: "open",
  },
  {
    path: "/relatorios",
    name: "Relatórios",
    key: "5",
    rtlName: "Relatorio2",
    icon: AssessmentIcon,
    component: Relatorios,
    layout: "/admin",
    click: "open",
  },
  
  {
    path: "/pedidos",
    name: "Pedidos de Venda",
    key: "4",
    rtlName: "Pedidos",
    icon: ContactsIcon,
    component: Pedidos,
    layout: "/admin",
    click: "open",
  },
];
/* 
 { 
    path: "/relatorios",
    name: "Relatórios",
    key: "5",
    rtlName: "Relatorio2",
    icon: AssessmentIcon,
    component: Relatorios,
    layout: "/admin",
    click: "",
    submenu:[
      {
        path: "/relatorios/EGR1000",
        name: "Contas a receber",
        key: "6",
        rtlName: "Relatorio1",
        icon: ArrowRight,
        component: Relatorio1,
        layout: "/admin",
        click: "open"
      },
      {
        path: "/relatorios/EIR4002",
        name: "Comissões",
        key: "7",
        rtlName: "Relatorio3",
        icon: ArrowRight,
        component: Relatorio3,
        layout: "/admin",
        click: "open"
      },
      {
        path: "/relatorios/EIR6000",
        name: "Ranking de vendas",
        key: "8",
        rtlName: "Relatorio2",
        icon: ArrowRight,
        component: Relatorio2,
        layout: "/admin",
        click: "open"
      },
      {
        path: "/relatorios/PRONTAENTREGA",
        name: "Pronta Entrega",
        key: "9",
        rtlName: "Relatorio4",
        icon: ArrowRight,
        component: Relatorio4,
        layout: "/admin",
        click: "open"
      },
      {
        path: "/relatorios/PROGRAMACAO",
        name: "Programação",
        key: "10",
        rtlName: "Relatorio5",
        icon: ArrowRight,
        component: Relatorio5,
        layout: "/admin",
        click: "open"
      },
      {
        path: "/relatorios/VENDAANALITICO",
        name: "Venda Analítico",
        key: "11",
        rtlName: "Relatorio6",
        icon: ArrowRight,
        component: Relatorio6,
        layout: "/admin",
        click: "open"
      }


    ]*/
export default dashboardRoutes;
